import { createFileRoute } from '@tanstack/react-router';
import { MarketingShell } from '@/components/marketing/MarketingShell';
import { CookiesPage } from '@/components/marketing/LegalPages';

export const Route = createFileRoute('/_public/cookies')({
  component: () => (
    <MarketingShell currentPath="/cookies">
      <CookiesPage />
    </MarketingShell>
  ),
});
